import { dataPieChartSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPieChartSolid = /*#__PURE__*/createIcon(dataPieChartSolid)
export default IconPieChartSolid
